module.exports = "<report-component [title]=\"'ALL_DEMAND' | dictionary\" [injectedDimensions]=\"[2]\" [reportLink]=\"'demand/all'\"></report-component>\n"